'use client';

import * as React from 'react';
import * as TabsPrimitive from '@radix-ui/react-tabs';
import * as Styled from './styled';
const Tabs = TabsPrimitive.Root;

const TabsList = React.forwardRef<
  React.ElementRef<typeof Styled.List>,
  React.ComponentPropsWithoutRef<typeof Styled.List> & { open?: boolean }
>(({ className, open, ...props }, ref) => <Styled.List ref={ref} $open={open} {...props} />);
TabsList.displayName = Styled.List.displayName;

const TabsTrigger = React.forwardRef<
  React.ElementRef<typeof Styled.Trigger>,
  React.ComponentPropsWithoutRef<typeof Styled.Trigger> & { small?: boolean; open?: boolean }
>(({ className, small, open, ...props }, ref) => <Styled.Trigger $small={small} $open={open} ref={ref} {...props} />);
TabsTrigger.displayName = Styled.Trigger.displayName;

const TabsContent = React.forwardRef<
  React.ElementRef<typeof Styled.Content>,
  React.ComponentPropsWithoutRef<typeof Styled.Content> & { open?: boolean }
>(({ className, open, ...props }, ref) => <Styled.Content ref={ref} $open={open} {...props} />);
TabsContent.displayName = Styled.Content.displayName;

// export { Tabs, TabsList, TabsTrigger, TabsContent };

export default Object.assign(Tabs, {
  List: TabsList,
  Trigger: TabsTrigger,
  Content: TabsContent,
});
